import { PostRequest, successParam } from '@/api/base';

export function linkPmAccount(params: object, onSuccess: successParam, onFailed: Function) {
    PostRequest('v4/web/common/manage/pm/linkSite', params, onSuccess, onFailed);
}

export default null;
